import type { StorePageConfig } from '@/app/(football)/[team]/store/_context/types';

export const jbfcConfig: StorePageConfig = {
  titleSection: {
    title: '스토어',
    highlight: '전북 현대 모터스',
    description: '그린카드 상품을 만나보세요',
  },
};
